import theme from '../../base';

const breadcrumb = {
  active: {
    foreground: theme.colors.blues.blue700,
  },
  disabled: {
    foreground: theme.colors.neutrals.gray800,
  },
};

export default breadcrumb;
